

























































import { Component, Vue, Prop } from "vue-property-decorator";
import { DeleteStudents$ } from "@/request/jxgl";
@Component({})
export default class StudentList extends Vue {
  @Prop()
  private students;
  @Prop()
  private filters;
  private selectChange(value, row) {
    this.$emit("selectChange", value, row);
  }
  /**
   * @description 编辑
   */
  private compose(row) {
    this.$router.push({
      path: "/main/jxgl/xs-detail",
      query: {
        id: row["user_id"],
      },
    });
  }
  /**
   * @description 删除
   */
  private deleteThis(row) {
    this.$confirm("删除后将无法找回，您确定要删除么？", {
      title: "温馨提示",
    })
      .then((value) => {
        const params: any = {
          data: {
            user_ids: [row["user_id"]],
          },
        };
        DeleteStudents$(this, params).then((data: any) => {
          this.$message.success("删除成功");
          this.$emit("deleteDone");
        });
      })
      .catch((err: any) => {
        console.log(err);
      });
  }
}
